function createRecipient() {
  return {
    id: crypto.randomUUID
      ? crypto.randomUUID()
      : Math.random().toString(36).slice(2),
    receiver_name: '',
    receiver_email: '',
    value: '',
  }
}

const getInitialData = () => {
  const today = new Date()
  return {
    recipients: [createRecipient()],
    send_date: {
      month: today.getMonth() + 1,
      day: today.getDate(),
      year: today.getFullYear(),
    },
    sender_name: '',
    sender_email: '',
    receiver_message: '',
  }
}
export const useGiftcardCheckout = defineStore('giftcardCheckout', () => {
  const formData = ref(getInitialData())

  const isReadyForPayment = computed(() => formData.value.recipients.length > 0)
  const giftCardTotal = computed(() => {
    return formData.value.recipients.reduce(
      (acc, cur) => acc + Number(cur.value),
      0,
    )
  })

  function setFormData(data) {
    const recipients = Array.isArray(data.recipients)
      ? data.recipients
      : [data.recipients]
    Object.assign(formData.value, {
      ...data,
      recipients,
    })
  }

  function resetData() {
    formData.value = getInitialData()
  }

  function addRecipient() {
    formData.value.recipients.push(createRecipient())
  }

  function removeRecipient(id) {
    const idx = formData.value.recipients.findIndex((r) => r.id === id)
    if (idx !== -1 && formData.value.recipients.length > 1) {
      formData.value.recipients.splice(idx, 1)
    } else {
      console.warn('At least one recipient is required.')
    }
  }
  function isFormValid(auth) {
    const data = formData.value
    if (!data) return false
    // Recipients
    if (!Array.isArray(data.recipients) || data.recipients.length === 0)
      return false
    for (const r of data.recipients) {
      if (!r.receiver_name || !r.receiver_email || !r.value) return false
    }
    // Sender
    if (!data.sender_name) return false
    if (auth && !auth.loggedIn && !data.sender_email) return false
    if (!data.receiver_message) return false
    if (
      !data.send_date ||
      !data.send_date.month ||
      !data.send_date.day ||
      !data.send_date.year
    )
      return false
    return true
  }

  return {
    formData,
    giftCardTotal,
    isReadyForPayment,
    setFormData,
    resetData,
    addRecipient,
    removeRecipient,
    isFormValid,
  }
})
